import { get } from "@/services/axiosUitils";

const baseUrl = "/nps/digilocker-authorize/";

class DigilockerAutorizeService {
  digilockerAutorize = async (): Promise<any> => {
    const response = await get<any>(`${baseUrl}`);
    return response;
  };
}

const instance = new DigilockerAutorizeService();
export default instance;
